export const uiTextBlock = {
    name: 'UI Text Block',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        text: {
            name: 'Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                {
                    nodes: {
                        'embedded-entry-block': [{ linkContentType: ['uiImage'] }],
                        'embedded-entry-inline': [{ linkContentType: ['uiTooltip'] }]
                    }
                },
                {
                    enabledNodeTypes: [
                        'heading-1',
                        'heading-2',
                        'heading-3',
                        'heading-4',
                        'heading-5',
                        'heading-6',
                        'ordered-list',
                        'unordered-list',
                        'hr',
                        'blockquote',
                        'hyperlink',
                        'entry-hyperlink',
                        'embedded-entry-inline',
                        'embedded-entry-block'
                    ],
                    message: 'Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, link to Url, link to entry, inline entry, and block entry nodes are allowed'
                }
            ]
        },
        orderedListAppearance: {
            name: 'Ordered list appearance',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Number', 'UpperAlpha'] }]
        }
    }
};
//# sourceMappingURL=uiTextBlock.js.map